import Grid from "@mui/material/Grid2";
import { FormGroup, Select } from "@cofano/cck";
import { Controller, useFormContext } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { Fragment, ReactNode } from "react";
import { AgreementFormByTypeProps } from "view/agreements/schema/schema";
import FormField from "components/cck/FormField";
import { DeclarationMonthTerm } from "__generated__/graphql";

type FormValues = {
	agreements: {
		availableHoursADay?: number;
		workdays?: number;
		declarationMonthTerm?: DeclarationMonthTerm;
	}[];
}

type FormField = {
	id: string;
	render: () => ReactNode;
}

const RentAgreementForm = ({ index, hiddenFields }: AgreementFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const RentAgreementFormFields: FormField[] = [
		{
			id: "agreement.availableHoursADay",
			render: () => (
				<Grid size={{ md: 4, xs: 12 }}>
					<FormField errors={errors} name={`agreements.${index}.availableHoursADay`}>
						<FormGroup label={intl.formatMessage({ id: "SHIP_AVAILABLE_HOURS_A_DAY" })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.availableHoursADay`}
								rules={{ required: true }}
								control={control}
								render={({ field }) => (
									<Select
										{...field}
										fetchOptions={[ 12, 14, 16, 18, 24 ]}
										clearable={false}
										disableSearch />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
		{
			id: "agreement.workdays",
			render: () => (
				<Grid size={{ md: 4, xs: 12 }}>
					<FormField errors={errors} name={`agreements.${index}.workdays`}>
						<FormGroup label={intl.formatMessage({ id: "SHIP_AVAILABLE_DAYS" })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.workdays`}
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<Select
										{...field}
										fetchOptions={[ 1, 2, 3 ]}
										getOptionLabel={option => intl.formatMessage({ id: `SHIP_AVAILABLEDAYS_${option}` })}
										clearable={false}
										disableSearch />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
		{
			id: "agreement.declarationMonthTerm",
			render: () => (
				<Grid size={{ md: 4, xs: 12 }}>
					<FormField errors={errors} name={`agreements.${index}.declarationMonthTerm`}>
						<FormGroup label={intl.formatMessage({ id: "DECLARATION_MONTH_TERM" })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.declarationMonthTerm`}
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<Select
										{...field}
										fetchOptions={Object.values(DeclarationMonthTerm)}
										getOptionLabel={option => intl.formatMessage({ id: `DECLARATION_MONTH_TERM_${option}` })}
										clearable={false}
										disableSearch />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
	];

	return (
		<>
			{RentAgreementFormFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default RentAgreementForm;
